export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=6054c5b4498fd2cef2944f0af04e599efbb8385948&name=fetchTypeahead!'